module.exports = __webpack_public_path__ + "img/transferencia.d47e9052.svg";